import { currencyFormatDE } from "lib/transformers"
import { React, useContext } from "react"
import i18n from "i18n"
import { getCurrency } from "utils/functions"
import AuthContext from "context/auth/authContext"
import { TOTALS } from "constants/decimals"
import { useDecimalFormatter } from "hooks/useDecimalFormatter"

export const getLastRow = (preferencias, capitulo) => {
  const { user } = useContext(AuthContext)

  const { getDecimals } = useDecimalFormatter()

  return (
    <>
      {
        // Skip first columns
        <td
          colSpan={preferencias.basededatos ? 4 : 2}
          style={{ borderRight: "1px solid #B7B7B7" }}
        ></td>
      }
      {preferencias.precioCoste && (
        <>
          <td style={{ paddingLeft: "0px" }}>{i18n.t("Total")}</td>
          <td style={{ paddingLeft: "0px", borderRight: "1px solid #B7B7B7" }}>
            {currencyFormatDE(
              parseFloat(capitulo.price),
              "",
              getDecimals(TOTALS),
            )}
          </td>
        </>
      )}
      {preferencias.costeReducido && (
        <>
          <td></td>
          <td style={{ paddingLeft: "0px" }}>{i18n.t("Total")}</td>
          <td style={{ paddingLeft: "0px", borderRight: "1px solid #B7B7B7" }}>
            {currencyFormatDE(
              parseFloat(capitulo.priceReduced ?? capitulo.price),
              "",
              getDecimals(TOTALS),
            )}
          </td>
        </>
      )}
      {preferencias.costReal && (
        <>
          {preferencias.basededatos ? <td></td> : null}
          <td style={{ paddingLeft: "0px" }}>{i18n.t("Total")}</td>
          <td style={{ paddingLeft: "0px" }}>
            {currencyFormatDE(
              parseFloat(capitulo.costReal),
              "",
              getDecimals(TOTALS),
            )}
          </td>
        </>
      )}
      {preferencias.clientPrice && (
        <>
          <td style={{ paddingLeft: "0px", borderLeft: "1px solid #B7B7B7" }}>
            {i18n.t("Total")}
          </td>
          <td style={{ paddingLeft: "0px" }}>
            {currencyFormatDE(
              parseFloat(capitulo.clientPriceWithoutDiscount),
              "",
              getDecimals(TOTALS),
            )}
          </td>
        </>
      )}
      {preferencias.descuento && (
        <>
          <td style={{ paddingLeft: "0px", borderLeft: "1px solid #B7B7B7" }}>
            {i18n.t("Total")}
          </td>
          <td style={{ paddingLeft: "0px" }}>
            {currencyFormatDE(
              parseFloat(capitulo.clientPrice),
              "",
              getDecimals(TOTALS),
            )}
          </td>
        </>
      )}
      {
        // Options
        <td></td>
      }
    </>
  )
}
